<div id="sidebar-panel" class="mailbox sidebar left border-right scroll-y">
  <!-- ให้แสดงเฉพาะ mobile/ipad จนกว่าจะมี design การเปิด/ปิด sidebar ของ pc -->
  <button *ngIf="!isDesktop" title="Menu" id="sidebar-toggle-btn" class="btn btn-link menu-btn sq-btn rounded-0" type="button"
    (click)="toggleSidebar()">
    <span class="fa fa-bars icon-grey font-20"></span>
  </button>
  <a id="promptpost-logo" title="Home" class="navbar-logo" [routerLink]="['/dashboard']">
    <img class="logo_image my-2 mt-3 ml-3" src="assets/img/logo-promptpost.png" width="119" alt=""
      [routerLink]="['/dashboard']">
  </a>

  <ul class="nav flex-column mt-3" id="sidebar-menu">
    <ng-container *ngIf="menus != null && menus.length > 0; else permissionNotFound">
      <ng-container *ngFor="let menu of menus;">
        <ng-container *ngIf="menu.submenu.length != '0'">
          <li class="nav-item" [class.show]="showMenu == menu.id">
            <a title="{{menu.name | translate}}" id="sidebar-menu-{{menu.id}}" [routerLink]="[]" class="menudropdown nav-link"
              (click)="addExpandClass(menu.id)" target="_self">
              <!-- <i class="icon fa {{menu.icon}}" *ngIf="menu.icon"></i> -->
              <img src="assets/img/{{menu.icon}}.png" width="40" alt="">
              &nbsp;{{menu.name | translate}}<i class="arrow fa fa-angle-down mt-2"></i>
            </a>
            <ul class="nav flex-column nav-second-level" [class.d-block]="showMenu == menu.id">
              <li *ngFor="let submenu of menu.submenu;" class="nav-item">
                <a title="{{submenu.name | translate}}" id="sidebar-sub-menu-{{submenu.id}}" routerLink="{{submenu.url}}"
                  (click)="menuChange(submenu,submenu.url)" [routerLinkActive]="['active']" class="nav-link"><i
                    class="icon fa {{submenu.icon}}" *ngIf="submenu.icon"></i>
                  {{submenu.name | translate}}
                  <span class="float-right mr-3" *ngIf="submenu.parentMenuId == 1">
                    {{countInboxUnread}}
                  </span>
                  <span class="float-right mr-3" *ngIf="submenu.parentMenuId == 3">
                    {{countDrafts}}
                  </span>

                </a>
              </li>
            </ul>
          </li>
        </ng-container>
        <ng-container *ngIf="menu.submenu.length == '0'">
          <li class="sidebar-menu nav-item">
            <a id="sidebar-menu-{{menu.id}}" routerLink="{{menu.url}}" (click)="addExpandClass(menu.id)"
              [routerLinkActive]="['active']" target="_self">
              <i class="icon fa {{menu.icon}}" *ngIf="menu.icon"></i>&nbsp;{{menu.name}}
            </a>
          </li>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-template #permissionNotFound>
      <div class="text-center m-3">
        <strong class="text-danger">No menu permission found.</strong>
      </div>
    </ng-template>
  </ul>
  <div class="row ml-2 mt-3">
    <div class="col-12">
      <span class="text-dark">{{'DIGITALMAILBOX.Storage' | translate}}</span>
    </div>
    <div class="col-12 mb-2">
      <span class="text-muted">{{'DIGITALMAILBOX.StorageUsage' | translate:({value: value | byteFormat, max: 524288000 | byteFormat})}}</span>
    </div>
    <div class="col-8 mt-1">
      <progressbar class="" [max]="524288000" [value]="value" type="info" [striped]="true" [animate]="false">

      </progressbar>

    </div>
    <div class="col-4 text-muted">{{(usagePercent >= 100)? 'Full':usagePercent + '%'}} </div>
  </div>


  <div class="fixed-buttom">
    <div class="text-center">
      <div class="btn-group mb-3" id="btn-translate">
        <button id="btn-translate-thai" class="btn-lang btn-left" (click)="changeLanguage('TH')" [ngClass]="{ 'active': lang == 'TH' }">TH</button>
        <button id="btn-translate-eng" class="btn-lang btn-right" (click)="changeLanguage('EN')" [ngClass]="{ 'active': lang == 'EN' }">EN</button>
      </div>
    </div>
   
    <hr class="mt-0">
    <div class="d-block" dropdown>
      <div class="dropdown" dropdownToggle>
        <div class="col " >
          <div class="float-left text-dark mb-3">
            <figure class="avatar40 rounded-circle z3" *ngIf="profileImage">
              <img src="data:image/png;base64,{{profileImage}}" height="40" width="40" alt="">
            </figure>
            <img *ngIf="!profileImage" src="assets/img/digital-mailbox-avatar.png" height="40" width="40" alt=""
              onerror="this.onerror=null;this.src='assets/img/avatar.png'">
            <div class="h5 d-inline-block pl-2">
              <span>{{ currentUser.username | limitTo:"15" }}</span>
            </div>
          </div>    
          <span class="fa fa-2x fa-angle-right float-right text-muted icon-pointer"></span>
        </div>
        <div class="dropdown-menu dropdown-menu-right dropdown-top-right" *dropdownMenu>
          <a title="Profile" class="dropdown-item" (click)="profile()"><i class="fa fa-user-o mr-2 p-1" aria-hidden="true"></i>{{'PROFILE.Profile' | translate}}</a>
          <a title="Consent" class="dropdown-item" (click)="consent()"><i class="fa fa-check-square-o mr-2 p-1" aria-hidden="true"></i>{{'PROFILE.Consent' | translate}}</a>
          <a title="Dsmr" class="dropdown-item" (click)="dsrmClick()"><i class="fa fa-file-text-o mr-2 p-1" aria-hidden="true"></i>{{'PROFILE.Dsrm' | translate}}</a>
          <a title="Request KYC Code" class="dropdown-item" (click)="requestKYCCode()"><i class="fa fa-id-badge mr-2 p-1" aria-hidden="true"></i>{{'PROFILE.Request KYC Code' | translate}}</a>            
          <a title="Request KYC History" class="dropdown-item" (click)="requestKYCHistory()"><i class="fa fa-history mr-2 p-1" aria-hidden="true"></i>{{'PROFILE.Request KYC History' | translate}}</a>            
          <a title="Change Password" class="dropdown-item" (click)="changePassword()"><i class="fa fa-unlock-alt mr-2 p-1" aria-hidden="true"></i>{{'PROFILE.Change Password' | translate}}</a>
          <a title="Logout" class="dropdown-item" (click)="logout()"><i class="fa fa-power-off mr-2 p-1" aria-hidden="true"></i>{{'PROFILE.Logout' | translate}}</a>     
        </div>
      </div>
    </div>


    <!-- <a [routerLink]="[]" class="btn btn-link user-profile">
      <figure class="avatar40 rounded-circle z3" *ngIf="profileImage">
        <img src="data:image/png;base64,{{profileImage}}" height="40" width="40" alt="">
      </figure>

      <img *ngIf="!profileImage" src="assets/img/digital-mailbox-avatar.png" height="40" width="40" alt=""
        onerror="this.onerror=null;this.src='assets/img/avatar.png'">
      <div class="h5 d-inline-block pl-2">
        <span>{{ currentUser.username }}</span>
      </div>
    </a> -->
  </div>
</div>